import Service from "../service"
import AuthService from "../AuthService"

const Med = {
  getSearch(data) {
    return AuthService.get("/med?page="+data.dataSearch.paginate+
        "&user_id="+data.dataSearch.user_id+
        "&main_group="+data.main_group+
        "&name_en="+data.name_en+
        "&name_th="+data.name_th+
        "&spec_no="+data.spec_no+
        "&sub_group="+data.sub_group+
        "&year="+data.year
    );
  },
  getById(id) {
    return AuthService.get(`/med/${id}`)
  },
  getPDF() {
    return AuthService.get(`/test`)
  }
}

export default Med
